// A string that is always safe to log for a caught value.
//
// A thrown value is not necessarily an Error. An axios rejection carries the whole
// request and response — including the Authorization header and the request body —
// on the object itself, so logging the value is what leaks. `err.message || err`
// does not solve that: it falls back to the whole object exactly when the message
// is absent. Nothing here returns anything derived from the value except its own
// message string, and `typeof` for the fallback so a non-error is still
// diagnosable.
//
// The backend has the same function at express/utils/error-message.js.
export function errorMessage(err) {
  if (typeof err === 'string') return err;
  const message = err && err.message;
  if (typeof message === 'string' && message) return message;
  return `non-error thrown (${typeof err})`;
}

export default errorMessage;
